import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROFESSIONAL, GET_PROFESSIONAL_LOGO } from '../../services/graphql/queries/professional';
import { professionalActions } from '../../redux/slices/professionalSlice';
import { GetProfessionalType } from '../../services/graphql/queries/types';

export default function useGetProfessional(professionalId: string) {
  const { data, loading, refetch } = useQuery<GetProfessionalType>(GET_PROFESSIONAL, {
    variables: {
      id: professionalId
    }
  });

  const fetchProfessional = useCallback(() => {
    professionalActions.setCurrentProfessional(data?.getProfessional);
  }, [data]);

  return {
    data: data?.getProfessional,
    refetch,
    fetchData: fetchProfessional,
    loading
  };
};

export const useGetProfessionalLogo = (variant: 'sm' | 'md' | 'lg') => {
  const { data, loading, refetch } = useQuery<{ getProfessionalLogo: string }>(GET_PROFESSIONAL_LOGO, {
    variables: {
      variant
    }
  });

  const fetchProfessionalLogo = useCallback(() => {
    professionalActions.setCurrentProfessional(data?.getProfessionalLogo);
  }, [data]);

  return {
    data: data?.getProfessionalLogo,
    fetchData: fetchProfessionalLogo,
    refetch,
    loading
  };
};
